import { render, staticRenderFns } from "./TicketFullDescription.vue?vue&type=template&id=b9f9577a&scoped=true&"
import script from "./TicketFullDescription.vue?vue&type=script&lang=js&"
export * from "./TicketFullDescription.vue?vue&type=script&lang=js&"
import style0 from "./TicketFullDescription.vue?vue&type=style&index=0&id=b9f9577a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f9577a",
  null
  
)

export default component.exports